// Show the first tab and hide the rest
$("#tabs-nav li:first-child").addClass("active");
$(".tab-content").hide();
$(".tab-content:first").show();

// Click function
$("#tabs-nav li").click(function () {
  $("#tabs-nav li").removeClass("active");
  $(this).addClass("active");
  $(".tab-content").hide();

  var activeTab = $(this).find("a").attr("href");
  $(activeTab).show();
  return false;
});

document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("faq-search");

  searchInput.addEventListener("input", function () {
    const searchTerm = this.value.toLowerCase();
    const faqItems = document.querySelectorAll(".accordion");

    faqItems.forEach((item) => {
      const heading = item
        .querySelector(".accordion__title")
        .textContent.toLowerCase();
      const content = item
        .querySelector(".accordion__content")
        .textContent.toLowerCase();

      if (heading.includes(searchTerm) || content.includes(searchTerm)) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  });
});
